import React, { FC } from 'react';

import { Box, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { t } from 'state/intl/translations';

export interface IItemActionsProps {
  showEdit?: boolean;
  onEdit: () => void;
  onRemove: () => void;
}

const Layout = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
});

const StyledActionButton = addWithConfig(ActionButton).withConfig({
  _text: {
    color: Styles.color.primary,
    fontSize: 'sm',
  },
  style: {
    marginRight: 16,
  },
});

const ItemActions: FC<React.PropsWithChildren<IItemActionsProps>> = ({
  showEdit = true,
  onEdit,
  onRemove,
}) => {
  return (
    <Layout testID="item-actions">
      {showEdit && (
        <StyledActionButton
          aria-label={t('edit')}
          testID="edit-item-action"
          color="primary"
          variant={ActionButtonVariants.TEXT_ONLY}
          size={ActionButtonSizes.SMALL}
          onPress={onEdit}
        >
          {t('edit')}
        </StyledActionButton>
      )}
      <StyledActionButton
        aria-label={t('remove')}
        testID="remove-item-action"
        color="primary"
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        onPress={onRemove}
      >
        {t('remove')}
      </StyledActionButton>
    </Layout>
  );
};

export default ItemActions;
